export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'max'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Rank',
        category: 'BGG',
        description: 'Community ranking of the game.',
        summarise: {
            prefix: 'Ranked'
        }
    },
    rules: {
        linked: [],
        legacy: ['rank']
    }
}